<template>
    <div
        class="flex flex-col lg:flex-row items-start lg:items-center gap-6"
        v-if="nextChapter.chapter"
    >
        <router-link
            class="btn-base btn-10x-orange order-2 lg:order-1 whitespace-nowrap"
            :to="{
                name: 'Chapter',
                params: {
                    slug: course?.slug,
                    chapterSlug: nextChapter?.chapter.slug,
                },
            }"
            id="hs-course-start-next-chapter"
        >
            {{ nextChapter?.buttonTitle }}
        </router-link>
        <p class="text-slate-500 text-sm order-1 lg:order-2">
            {{ nextChapter?.chapter.title }}
        </p>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useCoursesStore } from '@/store/courses';
import { computed } from 'vue';

const store = useCoursesStore();

const { course, startNextChapter, finishChapter } = storeToRefs(store);

const nextChapter = computed(() => {
    let chapter = null;
    let buttonTitle = '';

    if (startNextChapter && startNextChapter.value) {
        chapter = startNextChapter.value;
        buttonTitle = 'Start next lesson';
    }

    if (!chapter && finishChapter && finishChapter.value) {
        chapter = finishChapter.value;
        buttonTitle = 'Finish lesson';
    }

    return {
        chapter: chapter,
        buttonTitle: buttonTitle,
    };
});
</script>
